import Grid from '@mui/material/Grid';
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import NewCompanyPopUp from '../NewCompanyPopUp';
import Webcam from "react-webcam";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import { Select} from '@mui/material';

export default function NewMailDialog({useData,searchThis,closeNewMail}){
    const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [capturing, setCapturing] = useState(true);
  const webcamRef = React.useRef(null);

  var showData = useData

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    setCapturing(false);
  };

  const handleRetake = () => {
    setCapturing(true);
    setImageSrc(null);
  };
  const [openTanggalOptions,setTanggalOptions] = useState(false)
  const PilihTanggal = () => {
    setTanggalOptions(true)
  };

  const [tanggalPengambilan,setTanggalPengambilan] = useState(new Date());

  const confirmTanggal = (event) => {
    updatesurat()
  }

  const closeOpenTanggalOptions = () => {
    setTanggalOptions(false)
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCapturing(true);
    setImageSrc(null);
  };

  const [nomorTandaTerima, setNomorTandaTerima] =useState();
  const [pengirim, setPengirim] =useState();
  const [selectedRooms, setSelectedRooms] = useState("Surat");
  const [selectedStorage, setSelectedStorage] = useState("Kotak Surat");
  const [storage,setStorage] = useState(["Kotak Surat", "Ruangan Management", "Meja Resepsionis", "Lemari Resepsionis"]);
  const [names,setNames] = useState(["Surat", "Paket Kecil", "Paket Besar", "Cairan", "Makanan", "Paket Sangat Besar"]);
    const [notes, setNotes] = useState();
    const [error,setError] = useState();
  const [tanggalKejadian,setTanggalKejadian] = useState(new Date())
  const [statNotify,setStatNotify] =useState("No")
  const [lokasi,setLokasi] = useState()
  const [categorias, setCategorias] = useState([]);
  const [fileURL,setFileURL] = useState()
  const getCategorias = async () => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
    }).then(response=>{
      setCategorias(response.data.pilihanAlamat);
  });
    //console.log(res);
  }
  useEffect(() => {
      getCategorias();
    
      //get foto pengirim
      //NPWP Key
      if(useData.dataSurat.pengambilanKey){
        if (Array.isArray(useData.dataSurat.pengambilanKey)) {
          useData.dataSurat.pengambilanKey.forEach(filename => {
            console.log(filename)
              axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                  responseType: 'blob' // Tell axios to get the response as a blob
              })
              .then((response) => {
                
                const contentType = response.headers['content-type'];
                console.log(response);
                console.log(response.headers)
                console.log(contentType)
                console.log("pengambilan key here")

                if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                  // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                  const blob = new Blob([response.data], { type: contentType });
                  const url = URL.createObjectURL(blob);
                  setImageSrc(url)
                  
              } else {
                  // For other file types, download the file
                  const link = document.createElement('a');
                  link.href = window.URL.createObjectURL(new Blob([response.data]));
                  link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                  document.body.appendChild(link);
                  link.click();
                  
              }
              })
              .catch((error) => {
                  console.log('Error fetching the file:', error);
              });
          });
      } else {
        
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${useData.dataSurat.pengambilanKey}`, {
          responseType: 'blob' // Tell axios to get the response as a blob
      })
      .then((response) => {
        const contentType = response.headers['content-type'];
        console.log(response);
        console.log(response.headers)
        console.log(contentType)
        if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
          // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
          const blob = new Blob([response.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          setImageSrc(url)

      } else {
          // For other file types, download the file
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', 'file'); // Modify the filename and extension as needed
          document.body.appendChild(link);
          link.click();

      }
      })
      .catch((error) => {
          console.log('Error fetching the file:', error);
      });
      }
      }

            //NPWP Key End
      //end foto pengirim
      if(useData.dataSurat.fotoKey){
        if (Array.isArray(useData.dataSurat.fotoKey)) {
          useData.dataSurat.fotoKey.forEach(filename => {
            console.log(filename)
              axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                  responseType: 'blob' // Tell axios to get the response as a blob
              })
              .then((response) => {
                const contentType = response.headers['content-type'];
                console.log(response);
                console.log(response.headers)
                console.log(contentType)
                if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                  // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                  const blob = new Blob([response.data], { type: contentType });
                  const url = URL.createObjectURL(blob);
                  setFileURL(url)
              } else {
                  // For other file types, download the file
                  const link = document.createElement('a');
                  link.href = window.URL.createObjectURL(new Blob([response.data]));
                  link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                  document.body.appendChild(link);
                  link.click();
              }
              })
              .catch((error) => {
                  console.log('Error fetching the file:', error);
              });
          });
      } else {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${useData.dataSurat.fotoKey}`, {
          responseType: 'blob' // Tell axios to get the response as a blob
      })
      .then((response) => {
        const contentType = response.headers['content-type'];
        console.log(response);
        console.log(response.headers)
        console.log(contentType)
        if (['image/png', 'image/jpeg','image/webp','image/jpg', 'image/gif', 'application/pdf'].includes(contentType)) {
          // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
          const blob = new Blob([response.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          setFileURL(url)

      } else {
          // For other file types, download the file
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', 'file'); // Modify the filename and extension as needed
          document.body.appendChild(link);
          link.click();
      }
      })
      .catch((error) => {
          console.log('Error fetching the file:', error);
      });
      }
      }
    
    
    
    }, [useData.dataSurat.fotoKey,useData.dataSurat.pengambilanKey])
    //Save Surat/Paket
    function dataURLtoBlob(dataurl) {
      if (dataurl) {
          var arr = dataurl.split(',');
          if(arr.length < 2) {
              console.error('Invalid dataurl:', dataurl);
              return null;
          }
          var mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while(n--){
              u8arr[n] = bstr.charCodeAt(n);
          }
          return new Blob([u8arr], {type:mime});
      }
      return null;
  }
  

    const blob = dataURLtoBlob(imageSrc??"");

    const updatesurat = () => {

            // Assuming that fileFoto is your file objects
            const filesToUpload = [
                { file: blob, name: 'fileFoto' },
              ];
  
              // Map over the files array and return an array of promises
              const uploadPromises = filesToUpload.map((fileObj) => {
                if (fileObj.file) { // if the file is not null, upload it
                  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`, {
                    params: {
                      filename: fileObj.name // send the filename to the server
                    }
                  })
                  .then(response => {
                    const uploadUrl = response.data.url;
                    const key = response.data.key; // Get the key from the response
  
                    return fetch(uploadUrl, {
                      method: 'PUT',
                      headers: {
                        'Content-Type': imageSrc.split(';')[0].slice(5),
                      },
                      body: fileObj.file
                    }).then(() => key); // After the file is uploaded, return the key
                  })
                  .catch(error => {
                    console.error('Error during file upload:', error);
                  });
                }
  
                // if the file is null, return a resolved promise with value null
                return Promise.resolve(null);
              });

              // Wait for all upload operations to finish
            Promise.all(uploadPromises)
            .then(fileKeys => {
              const [pengambilanKey] = fileKeys; // Extract keys from the resolved values array
              
              let dataSurat = 
                {
                  ...useData.dataSurat, // This spreads out all the properties in dataSurat
                  pengambilanKey,
                  tanggalPengambilan,

            }

              
              // Now, post the data to your endpoint
              axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateSurat`,{
                id: useData._id,
                dataSurat,
                statNotify:"Done",
              })
              .then((response) => {
                setTanggalOptions(false)
                setOpen(false);
                setCapturing(true);
              })
              .catch((error) => {
                console.log(error.message);
                setError(error.response.data.message);
              });
            })


       
    }
    //End save surat/paket
    return <Grid sx={{p:2}} container>
    <Dialog open={openTanggalOptions} onClose={closeOpenTanggalOptions}>
      <Grid sx={{p:2}} xs={12}>
      <Grid sx={{p:2}} xs={12}>Tanggal Diambil:</Grid>
        
            <LocalizationProvider dateAdapter={AdapterDateFns}>

      <MobileDatePicker 
          views={['year', 'month', 'day']}
          inputFormat="dd/MM/yyyy"
          value={tanggalPengambilan}
          onChange={(event)=>setTanggalPengambilan(event)}
          renderInput={(params) => 
              <TextField 
                  {...params} 
                  InputProps={{
                      endAdornment: (
                          <InputAdornment >
                              <CalendarMonthIcon />
                          </InputAdornment>
                      ),
                  }}
              />
          }
      />

      </LocalizationProvider>
      <Grid sx={{p:2}} xs={12}>
      <Button onClick={confirmTanggal}>Konfirmasi</Button>
      </Grid>
          
      </Grid>
    </Dialog>
    <Grid xs={6} container> 
      <Grid item xs={12}>
        <Typography>Foto Pengirim:</Typography>
        <Grid container item xs={12} sx={{mb:3, pr:20}}>
        <img src={fileURL} alt="file content" style={{width: "100%", height: "100%", objectFit: 'contain'}} />
        </Grid>
        <Grid >
        {imageSrc === null && (
            <Button onClick={handleOpen} variant="contained">Dokumen Diambil</Button>
        )}        </Grid>
        <Grid container item xs={12} sm={6} sx={{mt:1}}>
          {imageSrc && <><Typography>Foto Pengambilan:</Typography><img src={imageSrc} alt="Captured" style={{ maxWidth: '100%', height: 'auto' }} /></>}
        </Grid>
  </Grid>
    </Grid>
    <Grid xs={6}>
        <Typography variant="h5"><b>Data Paket/Surat</b></Typography>
        <Grid container>

            <Grid container xs={5.5} sx={{mt:3}}>
                Nomor Tanda Terima*
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
            <Grid container xs={6} sx={{mt:3}}>
                {useData.dataSurat.nomorTandaTerima}
            </Grid>

            <Grid container xs={5.5} sx={{mt:3}}>
                Pengirim*
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
            <Grid container xs={6} sx={{mt:3}}>
              {useData.dataSurat.pengirim}
            </Grid>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{"Take a Photo"}</DialogTitle>
        <DialogContent>
          {capturing ? (
            <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" />
          ) : (
            <img src={imageSrc} alt="Captured" />
          )}
        </DialogContent>
        <DialogActions>
          {capturing ? (
            <>
              <Button onClick={handleCapture} color="primary">
                Capture
              </Button>
              <Button onClick={handleClose} color="secondary">
                Cancel
              </Button>
            </>
          ) : (
            <>
              <Button onClick={PilihTanggal} color="primary">
                Pilih Tanggal Diambil
              </Button>
              <Button onClick={handleRetake} color="secondary">
                Retake
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Grid container sx={{mt:3}} xs={5.5}>
                Lokasi Penerimaan*
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
      <Grid container xs={6} sx={{mt:3}}>
      {useData.dataSurat.lokasi??"tidak ada data"}</Grid>
                            <Grid container sx={{mt:2}}></Grid>

<Grid item xs={12}>
  <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
</Grid>
<Grid container sx={{mt:3}} xs={5.5}>
                Tanggal Pengambilan
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
                <Grid container sm={6} sx={{mt:3}}>
                {useData.dataSurat.tanggalPengambilan??"Belum ada data"}
                </Grid>

            <Grid container sx={{mt:3}} xs={5.5}>
                Tanggal Penerimaan
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
                <Grid container sm={6} sx={{mt:3}}>
                {useData.dataSurat.tanggalKejadian??"tidak ada data"}
                </Grid>

            <Grid container sx={{mt:3}} xs={5.5}>
                Tipe Dokumen
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
            <Grid container xs={6} sx={{mt:3}}>
            {useData.dataSurat.TipeDok??"tidak ada data"}
            </Grid>

            <Grid container xs={5.5} sx={{mt:3}}>
                Disimpan
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
            <Grid container xs={6} sx={{mt:3}}>
            {useData.dataSurat.storage??"tidak ada data"}
            </Grid>
            <Grid container xs={5.5} sx={{mt:3}}>
                Notes
            </Grid>
            <Grid container xs={0.5} sx={{mt:3}}>:</Grid>
            <Grid container xs={6} sx={{mt:3}}>
            {useData.dataSurat.notes??"tidak ada data"}
            </Grid>

        </Grid>
        {error && <Grid className="error_text" sx={{mb:3, mt:3}}>{error}</Grid>}
        <Grid container>
            <Box display="flex" justifyContent="flex-end" width="100%">
            </Box>
        </Grid>
    </Grid>
    </Grid>
}